/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_It_Works_SubtitleInputs */

const en_landing_how_it_works_subtitle = /** @type {(inputs: Landing_How_It_Works_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three steps from the archive you already own to the workflows where commission is decided.`)
};

/**
* | output |
* | --- |
* | "Three steps from the archive you already own to the workflows where commission is decided." |
*
* @param {Landing_How_It_Works_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_how_it_works_subtitle = /** @type {((inputs?: Landing_How_It_Works_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_It_Works_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_how_it_works_subtitle(inputs)
});